<template>
  <div>
    <header3></header3>
    <router-view></router-view>
    <div style="width:100%;background: #fff;min-width: 1000px;"><footer1></footer1></div>
  </div>
</template>

<script>

  import header3 from '../../components/Header3'
  import footer1 from '../../components/Footer1'

  export default {
    components: {
      header3,
      footer1
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/usercenter/CenterRoot.vue